/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExpandWindow = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M4.5 12V4.5h15v14H11V20h8.598S21 19.49 21 18.5v-14S21 3 19.5 3h-15S3 3 3 4.5V12z" /><path fill="currentColor" d="M9 17c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3M15.5 8h-6l2 2-3 3 2 2 3-3 2 1.833z" /></svg>;
export default SvgExpandWindow;